/*requires context.js */
/*requires Set.js*/
//
// HEI base file to setup the HEIJS namespace
// and some basic functions in the namespace.
//
// The top-level namespace for all HEI javascript stuff (should be at least)
//
HEIJS = typeof (HEIJS) == "undefined" ? {} : HEIJS;
$.extend(HEIJS, {
  page: {},
  popup: {},
  context: new HEIJS.Context(),

  //
  // 'extend' code from Mozilla
  // https://developer.mozilla.org/En/Core_JavaScript_1.5_Guide/Inheritance
  // Used to set up inheritance between JS types.
  //
  extend: function (childtype, supertype) {
    for (var property in supertype.prototype) {
      if (typeof childtype.prototype[property] == "undefined")
        childtype.prototype[property] = supertype.prototype[property];
    }

    // so you can call this.__super.prototype.METHOD_NAME.apply(this, args[]);
    // to call overridden superclass methods
    // this.__super.call(this, arg1, arg2, ...) calls the parent constructor
    childtype.prototype.__super = supertype;

    return childtype;
  },

  registerNamespace: function (nspace) {
    var collection = nspace.split('.');
    var root = window;

    for (var i = 0; i < collection.length; i++) {
      if (!root[collection[i]]) {
        root[collection[i]] = {};
      }
      root = root[collection[i]];
    }
  },

  // Added by Ivan Markov 2/2012
  // Read a page's GET URL variables and return them as an associative array.
  // Reference: http://jquery-howto.blogspot.com/2009/09/get-url-parameters-values-with-jquery.html
  getRequestParameters: function (returnEmptyIfNone) {
    var vars = [], hash, indexOfQuestionMark = window.location.href.indexOf('?');
    if (returnEmptyIfNone && indexOfQuestionMark < 0) {
      return vars;
    }
    var hashes = window.location.href.slice(indexOfQuestionMark + 1).split('&');
    for (var i = 0; i < hashes.length; i++) {
      hash = hashes[i].split('=');
      vars.push(hash[0]);
      vars[hash[0]] = unescape(hash[1]);
    }
    return vars;
  },

  // Drew McMinn 12/2012 -- Get a querystring value by name
  getQueryStringValueByName: function (name) {
    name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
    var regexS = "[\\?&]" + name + "=([^&#]*)";
    var regex = new RegExp(regexS);
    var results = regex.exec(window.location.search);
    if (results == null)
      return "";
    else
      return decodeURIComponent(results[1].replace(/\+/g, " "));
  },

  addQueryStringToUrl: function (url, key, value) {
    indexOfQuestionMark = url.indexOf('?');
    if (indexOfQuestionMark < 0) {
      return url + "?" + escape(key) + "=" + escape(value);
    }
    else {
      return url + "&" + escape(key) + "=" + escape(value);
    }
  },

  generateGUID: function () {
    var d = Date.now();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.floor((d + Math.random() * 16) % 16);
      d = Math.floor(d / 16);
      return (c === 'x' ? r : (r & 0x7 | 0x8)).toString(16);
    });
  },

  sanitizeHtmlText: function (text) {
    if (!text) {
      return ''
    }

    return $('<div>').text(text).html();
  },

  //
  // Created by: Ultimater | http://webdeveloper.com/forum/member.php?u=30185
  //
  htmlEntityDecode: function (str) {
    var ta = document.createElement("textarea");
    ta.innerHTML = str.replace(/</g, "&lt;").replace(/>/g, "&gt;");
    return ta.value;
  },

  ajaxQueue: [],
  ajaxTimeout: null,
  dryAjaxCallCount: 0,
  executeCrossDomainCalls: function () {
    clearTimeout(HEIJS.ajaxTimeout);

    if (HEIJS.ajaxQueue.length == 0) {
      if (HEIJS.dryAjaxCallCount < 10) {
        HEIJS.dryAjaxCallCount++;
        HEIJS.ajaxTimeout = setTimeout(function () { HEIJS.executeCrossDomainCalls(); }, 500);
      }
      else {
        HEIJS.ajaxTimeout = null;
        HEIJS.dryAjaxCallCount = 0;
      }

      return;
    }

    HEIJS.doCrossDomainCallInternal(HEIJS.ajaxQueue.shift());
  },

  doCrossDomainCallInternal: function (crossDomainCall) {
    var jqxhr = $.ajax({
      url: HEIJS.context.convertToContextUri(crossDomainCall.url),
      data: crossDomainCall.data,
      dataType: 'jsonp',
      success: crossDomainCall.successCallback,
      type: 'GET'
    });

    // setup the timeout function
    crossDomainCall.timeoutTimer = setTimeout(function () { (crossDomainCall.timeoutCallback)(); }, crossDomainCall.timeout);
    return jqxhr;
  },

  doCrossDomainCall: function (url, data, callback, context, timeout, async) {
    timeout = timeout || 10000; // timeout of ten seconds by default

    if (callback && !$.isFunction(callback)) {
      if (console)
        console.log("Callback in doCrossDomainCall is not a function.");

      throw "Callback not a function.";
    }

    var crossDomainCall = {
      url: url,
      data: data,
      context: context,
      timeout: timeout,
      timeoutTimer: null
    };

    // callback on success
    crossDomainCall.successCallback = function (json, textStatus) {
      clearTimeout(crossDomainCall.timeoutTimer);
      if (callback) {
        callback.call(context, json);
      }
      if (!async) {
        HEIJS.executeCrossDomainCalls();
      }
    };

    // callback on a timeout.  a jsonp call will never actually
    // call the error function for an ajax call because it's not true
    // ajax--it's just a script tag that gets created and it's taken from there.
    // if, for example, the url is wrong, it won't ever load the script and won't
    // call the dynamic jsonp function created by jquery
    crossDomainCall.timeoutCallback = function () {
      var loadedText = $("head>script[src^='" + HEIJS.context.convertToContextUri(url) + "']").text();
      $("head>script[src^='" + url + "']").remove();

      var errMsg = "Call to '" + HEIJS.context.convertToContextUri(url) + "' timed out. " + loadedText;
      if (callback) {
        callback.call(context, { Success: false, Messages: [errMsg] }, errMsg);
      }
      if (!async) {
        HEIJS.executeCrossDomainCalls();
      }
    };

    if (!async) {
      HEIJS.ajaxQueue.push(crossDomainCall);
      if (HEIJS.ajaxTimeout == null)
        HEIJS.executeCrossDomainCalls();
      return null;
    }
    else {
      return HEIJS.doCrossDomainCallInternal(crossDomainCall);
    }
  },

  formatString: function (text) {
    var stringArgs = [];

    var formatFromObject = function (strToFormat, object) {
      var thingsToReplace = Array.from(new Set(strToFormat.match(/\{\w+\}/g)));

      if (thingsToReplace.length === 0) {
        return strToFormat;
      }

      for (var i = 0; i < thingsToReplace.length; i++) {
        var key = thingsToReplace[i].slice(1, -1);
        if (!object.hasOwnProperty(key)) {
          continue;
        }
        var regEx = new RegExp(thingsToReplace[i].replace(/[\{\}]/g, '\\$&'), 'g');
        strToFormat = strToFormat.replace(regEx, object[key]);
      }

      return strToFormat;
    };

    for (var i = 1; i < arguments.length; i++) {
      if (arguments[i].constructor === Object) {
        text = formatFromObject(text, arguments[i]);
      }
      else if (arguments[i].constructor === Array) {
        for (var j = 0; j < arguments[i].length; j++) {
          stringArgs.push(arguments[i][j] == null ? '' : arguments[i][j].toString());
        }
      }
      else {
        stringArgs.push(arguments[i] == null ? '' : arguments[i].toString());
      }
    }

    if (stringArgs.length === 0) {
      return text;
    }

    var thingsToReplace = new Set(text.match(/\{\d+\}/g));

    if (thingsToReplace.size !== stringArgs.length) {
      throw "Number of replacement strings does not match number of replacement terms";
    }

    thingsToReplace = Array.from(thingsToReplace).sort(function (a, b) {
      var aNum = parseInt(a.slice(1, -1));
      var bNum = parseInt(b.slice(1, -1));

      if (aNum < bNum) { return -1; }
      else if (aNum > bNum) { return 1; }
      else { return 0; }
    });

    for (var i = 0; i < thingsToReplace.length; i++) {
      var regEx = new RegExp(thingsToReplace[i].replace(/[\{\}]/g, '\\$&'), 'g');
      text = text.replace(regEx, stringArgs[i]);
    }

    return text;
  },

  /*
  Parameters:
    elementToInsert   required    the element that needs to be inserted
    array             required    the sorted array in which to insert the element
    getValue          optional    a function that takes an item from the array and returns the value to be compared (defaults to returning the item itself)
    ignoreDuplicates  optional    a boolean that, if true, prevents duplicates from being inserted into the array (defaults to false)

  Returns:
    the index of the newly inserted element or -1 if no insert occurred
  */
  binaryInsert: function (elementToInsert, array, getValue, ignoreDuplicates) {
    if (typeof getValue !== 'function') {
      getValue = function (item) { return item; };
    }

    var min = 0;
    var max = array.length - 1;
    var pivot;
    var elementValue = getValue(elementToInsert);
    var pivotValue;

    while (min <= max) {
      pivot = (min + max) / 2 | 0;
      pivotValue = getValue(array[pivot]);

      if (elementValue < pivotValue) {
        max = pivot - 1;
      }
      else if (elementValue > pivotValue) {
        min = pivot + 1;
      }
      else {
        if (ignoreDuplicates) {
          return -1;
        }

        break;
      }
    }

    array.splice(min, 0, elementToInsert);
    return min;
  },

  /*
  Parameters:
    valueToFind   required    the value needing to be found in the array
    array         required    the sorted array in which to look for the value
    getValue      optional    a function that takes an item from the array and returns the value to be compared (defaults to returning the item itself)

  Returns:
    the index of the first item found matching valueToFind
  */
  binarySearch: function (valueToFind, array, getValue) {
    if (typeof getValue !== 'function') {
      getValue = function (item) { return item; };
    }

    var min = 0;
    var max = array.length - 1;
    var pivot;
    var pivotValue;

    while (min <= max) {
      pivot = (min + max) / 2 | 0;
      pivotValue = getValue(array[pivot]);

      if (valueToFind < pivotValue) {
        max = pivot - 1;
      }
      else if (valueToFind > pivotValue) {
        min = pivot + 1;
      }
      else {
        return pivot;
      }
    }

    return -1;
  },

  // pads an integer left X number of places - Drew McMinn
  integerZeroPad: function (num, places) {
    if ((!num && num != 0) || !places || places <= 0) return;
    var zero = places - num.toString().length + 1;
    return Array(+(zero > 0 && zero)).join("0") + num;
  },

  // strips just the opening '<' and closing '>' tags from some text - Joe Bennett
  stripTags: function (text) {
    text = text.replace(/<|>/g, '');
    return text;
  },

  // strips HTML from a given string - Drew McMinn
  //Updated to remove just the html tags and not anything after a less than symbol (<)
  stripHTML: function (text) {
    return text.replace(/(<([^>]+)>)/ig, "");
  },

  // takes a date object and format string to return a formatted date string
  // ex: dateTimeFormat(someJSDateObj, "#M#/#D#/#YYYY# #h#:#mm# #AMPM#") = "3/12/2013 4:30 PM"
  // Drew McMinn
  dateTimeFormat: function (dateObject, formatString) {
    var YYYY, YY, MMMM, MMM, MM, M, DDDD, DDD, DD, D, hhh, hh, h, mm, m, ss, s, ampm, AMPM, dMod, th;
    YY = ((YYYY = dateObject.getFullYear()) + "").slice(-2);
    MM = (M = dateObject.getMonth() + 1) < 10 ? ('0' + M) : M;
    MMM = (MMMM = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][M - 1]).substring(0, 3);
    DD = (D = dateObject.getDate()) < 10 ? ('0' + D) : D;
    DDD = (DDDD = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][dateObject.getDay()]).substring(0, 3);
    th = (D >= 10 && D <= 20) ? 'th' : ((dMod = D % 10) == 1) ? 'st' : (dMod == 2) ? 'nd' : (dMod == 3) ? 'rd' : 'th';
    formatString = formatString.replace("#YYYY#", YYYY).replace("#YY#", YY).replace("#MMMM#", MMMM).replace("#MMM#", MMM).replace("#MM#", MM).replace("#M#", M).replace("#DDDD#", DDDD).replace("#DDD#", DDD).replace("#DD#", DD).replace("#D#", D).replace("#th#", th);

    h = (hhh = dateObject.getHours());
    if (h == 0) h = 24;
    if (h > 12) h -= 12;
    hh = h < 10 ? ('0' + h) : h;
    AMPM = (ampm = hhh < 12 ? 'am' : 'pm').toUpperCase();
    mm = (m = dateObject.getMinutes()) < 10 ? ('0' + m) : m;
    ss = (s = dateObject.getSeconds()) < 10 ? ('0' + s) : s;
    return formatString.replace("#hhh#", hhh).replace("#hh#", hh).replace("#h#", h).replace("#mm#", mm).replace("#m#", m).replace("#ss#", ss).replace("#s#", s).replace("#ampm#", ampm).replace("#AMPM#", AMPM);
  },

  toShortDateString: function (date) {
    return date == null ? '' : moment(date).format("M/D/YYYY");
  },

  aspNetJsonRegex: /^\/?Date\((\-?\d+)/i,
  toMomentFromJson: function (src) {
    //for old JSONDataPage serialized dates, the .net date is loaded in the servers local timezone (CST) and the moment.js library will load it as the same absolute time in the browsers local timezone
    //so, for example, 9:00AM CST on the server becomes 10:00AM EST in the browser in philly. We want to convert this to be relative, so that it comes across as 9:00AM EST.
    //however, for MVC actions (which is using JSON.NET serialization), the date is returned without any kind of timezone shifting applied. the moment.js library will load it directly the way we want it to.
    //examples: 
    //MVC/JSON.NET: 2016-04-08T08:59:57 
    //JSONDataPage/Old: /Date(1331144880000-0600)/
    var date = moment(src);
    if (this.aspNetJsonRegex.test(src)) { //test if we're looking at the old /Date()/ format and adjust by timezone. otherwise just return.
      //this is a special check for the 1/1/0001 date which we pass for null/empty date values. Chrome 67+ now interprets this differently because it has more detailed 
      //old timezone info that changes things than the c# code uses, so just hardcode the value we want here. It shouldn't be an issue for more recent dates.
      if (src == "/Date(-62135575200000-0600)/") return moment("0001-01-01T00:00:00");
      var serverTimezoneOffset = (parseInt(src.substring(src.length - 6, src.length - 4)) * 60) + parseInt(src.substring(src.length - 4, src.length - 2));
      return date.add(-date.utcOffset() - serverTimezoneOffset, 'minutes');
    }
    return date;
  },

  // takes a .net datetime json string (ex: /Date(1331144880000-0600)/ or 2016-04-08T08:59:57) and converts it to a javascript date object with the same relative time in the current timezone
  toDateFromJson: function (src) {
    return this.toMomentFromJson(src).toDate();
  },

  getCurrentFormattedTimeForTimezone: function (timezone, momentJsFormat) {
    var timezoneIndicator = '';
    var format = momentJsFormat == null || momentJsFormat == '' ? 'h:mm a z' : momentJsFormat;
    switch (timezone) {
      case 'Central Standard Time':
        timezoneIndicator = 'America/Chicago';
        break;
      case 'Eastern Standard Time':
        timezoneIndicator = 'America/New_York';
        break;
      case 'Pacific Standard Time':
        timezoneIndicator = 'America/Los_Angeles';
        break;
      case 'Mountain Standard Time':
        timezoneIndicator = 'America/Denver';
        break;
      case 'US Mountain Standard Time':
        timezoneIndicator = 'America/Phoenix';
        break;
    }
    var now = moment.tz(timezoneIndicator).format(format);
    return now;
  },

  handleError: function (msg, url, line, col, error) {
	if (msg == 'ResizeObserver loop limit exceeded') return; //ResizeObserver will throw this if it can't deliver all observations in a single animation frame, but is safe to ignore. stop spamming our logs with it. 
	//see https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded. alternatively we could put the js code in each resizeobserver within a window.requestAnimationFrame as described there, but there doesn't seem to be a need for doing so.
    var self = this;
    new RESTService({ baseUrl: HEIJS.context.convertToContextUri('https://svc.hendersonengineers.com/Logging'), routePrefix: 'Error/API' })
      .Create('LogError', {
        message: msg,
        url: url,
        line: line,
        column: col,
        stack: error ? error.stack : '',
        user: $(".username .infobar-widget-menu-title").first().text()
      });
    if (typeof (console) != "undefined") {
      console.error(msg + " in " + url + " on line " + line + "col: " + col);
    }
  },

  dictionaryToObject: function (dictionary) {
    var object = {};
    for (var idx = 0; idx < dictionary.length; idx++) {
      object[dictionary[idx].Key] = dictionary[idx].Value;
    }

    return object;
  },

  objectToDictionary: function (object) {
    var dictionary = [];
    for (var key in object) {
      dictionary.push({ Key: key, Value: object[key] });
    }
    return dictionary;
  },

  // extra logic added for IE10 -DM
  // http://stackoverflow.com/questions/8112634/jquery-detecting-cookies-enabled
  cookiesEnabled: function () {
    var cookieEnabled = navigator.cookieEnabled;

    // When cookieEnabled flag is present and false then cookies are disabled.
    if (cookieEnabled === false) return false;

    // try to set a test cookie if we can't see any cookies and we're using 
    // either a browser that doesn't support navigator.cookieEnabled
    // or IE (which always returns true for navigator.cookieEnabled)
    if (!document.cookie && (cookieEnabled === null || /*@cc_on!@*/false)) {
      document.cookie = "testcookie=1";
      if (!document.cookie) return false;
      else document.cookie = "testcookie=; expires=" + new Date(0).toUTCString(); // expires immediately
    }

    return true;
  },

  createCookie: function (name, value, days) {
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      var expires = "; expires=" + date.toGMTString();
    }
    else var expires = "";
    document.cookie = name + "=" + value + expires + "; path=/";
  },

  readCookie: function (name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  },

  relativeScroll: function (container, parent) {
    if (!container) return;
    var $parent = !parent ? $(container).parent() : $(parent);
    $parent.mousewheel(function (event, delta, deltaX, deltaY) {
      var $bottom = $(container);
      if (($bottom.scrollTop() == 0 && deltaY > 0) || ($bottom.scrollTop() === ($bottom.prop('scrollHeight') - $bottom.outerHeight()) && deltaY < 0)) {
        event.preventDefault();
      }
    });
  },

  eraseCookie: function (name) {
    createCookie(name, "", -1);
  },

  requireIEDocModeVersion: function (version, message) {
    var ok = true;
    if ($.browser.msie) {
      //documentMode property exists in IE8+. Before that, just check the browser version.
      if (document.documentMode) {
        ok = document.documentMode >= version;
      }
      else {
        ok = parseInt($.browser.version) >= version;
      }
    }
    if (!ok && message) {
      if (message === true) { //pass in true for a default message, otherwise pass in the message string directly. Or false/nothing to show no message here and handle the return value in the caller.
        message = "This page requires at least IE" + version + ", and it must not be in compatibility mode.";
      }
      new HEIJS.Controls.NotyMessage(message, 'ui-icon-info', true, { layout: 'top', type: 'error' }).showMessages();
    }
    return ok;
  },

  cleanLyncPresence: function (availability, lastActive, deviceType) {
    var presence = availability || "Unknown";
    if (lastActive && availability != 'Available') {
      var date = moment(lastActive);
      var d = moment(date).fromNow(true);
      var currentDate = moment();

      // make sure the difference is not negative and isn't a datetime.minvalue
      if ((/\d/.test(d) && parseInt(d) > 0 && currentDate.diff(date, 'years') != currentDate.format('YYYY') - 1) || /\d/.test(d) == false) {
        presence += (" " + d);
      }
    }
    if (deviceType == 'Mobile') presence += ' - Mobile';
    return presence;
  },

  serializeAJAXParams: function (object) {
    //note: this function is destructive

    for (var prop in object) {
      if (object[prop] != null && object[prop].constructor === Array) {
        object[prop] = JSON.stringify(object[prop]);
      }
    }
    return object;
  },

  // calendarElement is a jQuery object
  // additionalElementsToHide and additionalEventTextElements are jQuery selector strings for elements that can be found inside calendarElement
  printCalendar: function (calendarElement, additionalElementsToHide, additionalEventTextElements) {
    var calendarParent = calendarElement.parent();

    calendarElement.appendTo('body');
    $('body').find('*').addClass('notPrintingCalendar');
    calendarElement.addClass('printingCalendar').removeClass('notPrintingCalendar').find('*').removeClass('notPrintingCalendar');
    calendarElement.find('.fc-toolbar').find('*').addClass('notPrintingCalendar');
    calendarElement.find('.fc-toolbar').find('h2').removeClass('notPrintingCalendar').parents().removeClass('notPrintingCalendar');
    calendarElement.find('.fc-content').find('*').addClass('printingEventText');
    calendarElement.find(additionalElementsToHide).addClass('notPrintingCalendar');
    calendarElement.find(additionalEventTextElements).addClass('printingEventText').addClass('notRegularContent');

    window.print();

    calendarElement.removeClass('printingCalendar').appendTo(calendarParent);
    $('.notPrintingCalendar').removeClass('notPrintingCalendar');
    $('.printingEventText').removeClass('printingEventText');
  },

  ensureDevExpressDataVisualizationLoaded: function (callback) {
    if (!$().dxChart) {
      $.getScript(HEIJS.context.convertToContextUri('https://apps.hendersonengineers.com/resources/js/thirdparty.all.js'), callback);
    }
    else {
      callback();
    }
  },

  getHashParam: function (name) {
    var hashParams = {};
    var e;
    var a = /\+/g;  // Regex for replacing addition symbol with a space
    var r = /([^&;=]+)=?([^&;]*)/g;
    var d = function (s) { return decodeURIComponent(s.replace(a, " ")); };
    var q = window.location.hash.substring(1);

    while (e = r.exec(q)) {
      hashParams[d(e[1])] = d(e[2]);
    }

    return !!name ? hashParams[name] : hashParams;
  },

  getIconFromFilename: function (fileName) {
    var fileExtension = fileName.substr((~-fileName.lastIndexOf(".") >>> 0) + 2).toLowerCase();

    switch (fileExtension) {
      case 'txt':
        return 'fa-file-alt';

      case 'pdf':
        return 'fa-file-pdf';

      case 'xls':
      case 'xlsx':
      case 'xlsm':
      case 'xlsb':
      case 'csv':
      case 'xlt':
      case 'xltx':
        return 'fa-file-excel';

      case 'ppt':
      case 'pptx':
      case 'pptm':
      case 'potx':
      case 'potm':
      case 'pps':
      case 'ppsx':
        return 'fa-file-powerpoint';

      case 'doc':
      case 'docx':
      case 'docm':
      case 'dot':
      case 'dotm':
      case 'dotx':
      case 'odt':
      case 'rtf':
        return 'fa-file-word';

      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
      case 'tif':
      case 'tiff':
      case 'bmp':
        return 'fa-file-image';

      case 'zip':
      case 'zipx':
      case '7z':
      case 'rar':
      case 'gz':
      case 'bz2':
        return 'fa-file-archive';

      case 'mp3':
      case 'mwa':
      case 'ra':
      case 'rm':
      case 'ram':
      case 'ogg':
      case 'wav':
      case 'flac':
      case 'm4a':
        return 'fa-file-audio';

      case 'avi':
      case 'flv':
      case 'mov':
      case 'mp4':
      case 'mpeg4':
      case 'webm':
        return 'fa-file-video';

      case 'cs':
      case 'js':
      case 'py':
      case 'sql':
        return 'fa-file-code';

      default:
        return 'fa-file';
    }
  },

  parseCurrency: function (val, fixed) {
    if (val < 0) {
      val = Math.abs(val);
      return "($" + val.toFixed(fixed).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") + ")";
    }
    return "$" + val.toFixed(fixed).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
  },

  parseFromCurrency: function (val) {
    return parseFloat(val.replace("$", "").replace("(", "-").replace(")", "").split(",").join(""));
  },

  userTimezoneGuess: null,

  getTimezone: function () {
    if (!moment.tz) {
      return 'America/Chicago';
    }

    if (this.userTimezoneGuess === null) {
      this.userTimezoneGuess = moment.tz.guess();
    }

    return this.userTimezoneGuess;
  },

  // Sees if any element in a jquery object is currently being hovered over
  isHovered: function (obj) {
    for (var i = 0; i < obj.length; i++) {
      if ($(obj[i]).is(':hover')) { return true; }
    }
    return false;
  },

  //apply on keydown event to restrict input to only whole numbers
  restrictToNumber: function (e) {
    HEIJS.__internalRestrictToNumber(e, false);
  },

  //apply on keydown event to restrict input to only whole numbers and a decimal point (.)
  restrictToDecimal: function (e) {
    HEIJS.__internalRestrictToNumber(e, true);
  },

  getAccessToken: function () {
    var shouldLog = localStorage.getItem('HendersonTokenLogging') === 'true';

    if (!HEIJS.__shouldAcquireAccessTokens()) {
      if (shouldLog) console.log('[HEIJS] [get access token] Forms auth detected. Skipping access token acquisition.');
      return '';
    }

    var inputToken = HEIJS.__getAccessTokenFromInput();

    if (inputToken) {
      if (shouldLog) console.log('[HEIJS] [get access token] Using token from input.');
      return inputToken;
    }

    if (shouldLog) console.log('[HEIJS] [get access token] Using token from localStorage.');
    return HEIJS.__getAccessTokenFromLocalStorage();
  },

  __getAccessTokenFromInput: function () {
    var el = document.getElementById('__accessToken');
    if (el && el.value) {
      return el.value;
    }
    return null;
  },

  __getAccessTokenFromLocalStorage: function () {
    return localStorage.getItem('HendersonAccessToken');
  },

  __shouldAcquireAccessTokens: function () {
    if (window.location.hostname.indexOf('.dev.hendersonengineers.com') >= 0) {
      return document.cookie.indexOf('.HendersonDevFormsMetadata=') === -1;
    }
    return document.cookie.indexOf('.HendersonFormsMetadata=') === -1;
  },

  convertProjectFromGraphqlToUpperCamel: function (p) {
    return {
      Department: p.department,
      Description: p.projectDescription,
      HEICompanyName: p.hendersonCompanyName,
      Indirect: p.indirect,
      IsConfidential: p.isConfidential,
      Address1: p.location.address1,
      Address2: p.location.address2,
      City: p.location.city,
      State: p.location.state,
      Country: p.location.countryCode,
      Phase: p.phase,
      PhaseDescription: p.phaseDescription,
      PhaseGroup: p.phaseGroup,
      PhaseType: p.phaseType,
      Practice: p.sector,
      PrincipalID: p.principalId,
      PrincipalName: p.principalName,
      Program: p.program,
      ProjectId: p.projectId,
      ProjectManager1ID: p.projectManager1Id,
      ProjectManager1Name: p.projectManager1Name,
      ProjectManager2ID: p.projectManager2Id,
      ProjectManager2Name: p.projectManager2Name,
      ProjectManager3ID: p.projectManager3Id,
      ProjectManager3Name: p.projectManager3Name,
      ProjectNumber: p.projectNumber,
      Status: p.status,
      StoreNumber: p.storeNumber,
      Subpractice: p.practice,
      SubType: p.subtype,
      TotalSize: p.totalSize,
      WBS1: p.wBS1
    };
  },

  __internalRestrictToNumber: function (e, allowDecimalPoint) {
    var allowedKeyCodes = [46, 8, 9, 27, 13]; //backspace, delete, tab, escape, enter

    if (allowDecimalPoint) {
      allowedKeyCodes.push(110);
      allowedKeyCodes.push(190);
    }

    if ($.inArray(e.which, allowedKeyCodes) !== -1 || //allow: all allowed keys
       (e.which == 65 && (e.ctrlKey === true || e.metaKey === true)) || //allow: ctrl+A, command+A
       (e.which >= 35 && e.which <= 40)) { //allow: home, end, left, right, down, up
      return;
    }

    if ((e.shiftKey || (e.which < 48 || e.which > 57)) && (e.which < 96 || e.which > 105)) { //ensure that it is a number and stop the keypress
      e.preventDefault();
    }
  }
});

$(document).ready(function () { HEIJS.context.init(); window.onerror = HEIJS.handleError; });